import { render } from "./PreselectionBox.vue?vue&type=template&id=41bd762e&scoped=true"
import script from "./PreselectionBox.vue?vue&type=script&lang=js"
export * from "./PreselectionBox.vue?vue&type=script&lang=js"

import "./PreselectionBox.vue?vue&type=style&index=0&id=41bd762e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41bd762e"]])

export default __exports__